import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';

const FloatingButtons = () => {
  return (
    <div className="fixed bottom-6 right-6 flex flex-col space-y-4 z-40">
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/66968826252"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-110 float-animation"
        title="Chat on WhatsApp"
      >
        <MessageCircle size={24} />
      </a>

      {/* LINE Button */}
      <a
        href="https://line.me/ti/p/~@karnidigital"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-green-400 hover:bg-green-500 text-white p-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-110 float-animation"
        title="Chat on LINE"
        style={{ animationDelay: '0.5s' }}
      >
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63h2.386c.349 0 .63.285.63.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771z"/>
        </svg>
      </a>

      {/* Call Button */}
      <a
        href="tel:+66968826252"
        className="bg-primary hover:bg-primary-700 text-white p-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-110 float-animation"
        title="Call Now"
        style={{ animationDelay: '1s' }}
      >
        <Phone size={24} />
      </a>
    </div>
  );
};

export default FloatingButtons;
